/* global Intercom */

import EventBase from './base.js'

export default class IntercomEvent extends EventBase {
  send() {
    typeof Intercom !== 'undefined' && Intercom('trackEvent', this.event, this.data)
  }
}
